// Keep relief legible above weather rasters, using the very same DEM geometry.
const RELIEF = ['ws-terrain-dem-hillshade', 'ws-terrain-sitr-hillshade'];
export function enforceTerrainReliefOrder(map) {
    const layers = map.getStyle()?.layers || [];
    const lastRaster = layers.reduce((last, layer, i) => layer.type === 'raster' ? i : last, -1);
    if (lastRaster < 0) return;
    const before = layers.slice(lastRaster + 1).find(layer => !RELIEF.includes(layer.id))?.id;
    for (const id of RELIEF) {
        const index = layers.findIndex(layer => layer.id === id);
        if (index >= 0 && index < lastRaster) map.moveLayer(id, before);
    }
}
export function syncTerrainRelief(map, source, enabled) {
    const active = source + '-hillshade';
    if (enabled) {
        const spec = map.getStyle()?.sources?.[source];
        if (!spec) return;
        const shadeSource = source + '-shade';
        // Independent DEM caches prevent terrain mesh / hillshade contention.
        if (!map.getSource(shadeSource)) map.addSource(shadeSource, {...spec});
        if (!map.getLayer(active)) {
            const before = map.getStyle().layers.find(layer => layer.type === 'symbol' || layer.type === 'circle')?.id;
            map.addLayer({id: active, type: 'hillshade', source: shadeSource,
                layout: {visibility: 'visible'},
                paint: {'hillshade-exaggeration': .38, 'hillshade-shadow-color': '#173444',
                    'hillshade-highlight-color': '#ffffff', 'hillshade-accent-color': '#768d85',
                    'hillshade-illumination-anchor': 'map', 'hillshade-illumination-direction': 315},
            }, before);
        }
    }
    for (const id of RELIEF) {
        if (map.getLayer(id)) map.setLayoutProperty(id, 'visibility', enabled && id === active ? 'visible' : 'none');
    }
    enforceTerrainReliefOrder(map);
}
